import { createPinia, PiniaVuePlugin } from 'pinia'
import Vue from "vue";

Vue.use(PiniaVuePlugin)

export const pinia = createPinia()

